import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogConfirmacionComponent } from '../../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { ErroresService } from '../../../../core/services/errores.service';
import { IboxtoolsItemUnico } from '../../../../models/iboxtools-item-unico';
import { NovedadesMes } from '../../../../models/novedadesMes';
import { NovedadesMesService } from '../../../../services/novedades-mes.service';
import { NovedadesMesDetalleComponent } from '../novedades-mes-detalle/novedades-mes-detalle.component';
import { GruposLiquidacionService } from '../../../../services/gruposLiquidacion.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-novedades-mes',
  templateUrl: './novedades-mes.component.html',
  styleUrls: ['./novedades-mes.component.css']
})
export class NovedadesMesComponent implements OnInit, OnChanges {

  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;
  disabledEditing: boolean;
  novedadMes: NovedadesMes;
  verDetalle: boolean = false;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  habilitarFormDetalle: boolean = false;
  MensajeError: string;

  //Control ibox
  novedadesMesHistoryList: any;
  novedadesMesList: NovedadesMes[];
  toolboxEnabled: boolean = false;
  onlyNew: boolean = true;
  novedadesMes: NovedadesMes[];
  buscando: boolean;
  cortarRegistro: boolean = false;

  ingreso: any;
  desdeAnterior: boolean = false;
  anteriorRetroactividad: boolean = false;
  novedadesInvalida: boolean = false;

  public cargaCompleta: boolean = false;

  @ViewChild('ChildNovedadMesDetalle') novedadMesDetalle: NovedadesMesDetalleComponent;

  constructor(private novedadesMesService: NovedadesMesService,
    private dialog: MatDialog,
    private erroresService: ErroresService,
    private snackBar: MatSnackBar, 
    private gruposLiquidacionService: GruposLiquidacionService,
    private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.obtenerNovedades(false);

    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Novedades Fijas")) this.permisoEdicion = true;
  }

  obtenerNovedades(agrupar)
  {
    this.buscando = true;
    this.novedadesMesService.getByPersonal(this.personalId, agrupar).subscribe(
      data =>
      {
        data.forEach((currentValue,index,arr) => {
          currentValue.fecha = this.momentService.convertDateServer(currentValue.fecha);
        });

        this.novedadesMes = data;
        this.buscando = false;
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        this.buscando = false;
        console.log(error);
      });
  }

  ngOnChanges(changes: SimpleChanges): void
  {
    //throw new Error("Method not implemented.");
  }

  async OnVisualizarDetalle(novedadPeriodo)
  {
    if (novedadPeriodo.id != 0)
    {
      this.obtenerHistorial(novedadPeriodo);
    }
    else
    {
      if (await this.verEstadoNomina())
      {
        this.verDetalle = true;
        this.novedadMes = novedadPeriodo;
        this.habilitarEdicion();
      }
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.novedadMes))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.novedadesMesService.eliminar(this.novedadMes.id).subscribe(
            response =>
            {
              this.snackBar.open("Eliminado correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              let novedadMes = this.novedadesMesList.filter(d => d.id != this.novedadMes.id)[0];
              if (novedadMes == undefined)
              {
                this.volverAtras();
              }

              this.obtenerHistorial(novedadMes);
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.novedadMes))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.novedadMesDetalle.form.controls['fecha'].disable();
      });
    }
  }

  OnPeriodChange(index: number)
  {
    let novedad = this.novedadesMesList.find(d => d.id == index);
    this.novedadMes = novedad;
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    this.novedadMesDetalle.setearForm(this.novedadMes);
    this.deshabilitarEdicion();
  }

  OnSaveChange(e: boolean)
  {
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.novedadMesDetalle.form.getRawValue();

      let datosNov: NovedadesMes = {
        id: formulario.id,
        personal: formulario.personal,
        fecha: this.momentService.saveDateServer(formulario.fecha, false),
        motivo: formulario.motivo,
        quincena: formulario.quincena,
        unidadMedida: formulario.unidadMedida,
        cantidad: formulario.cantidad,
        importe: formulario.importe,
        moneda: formulario.moneda,
        codigosNomina: formulario.codigosNomina
      };

      this.novedadesMesService.guardar(datosNov, this.cortarRegistro).subscribe(
        novedadPeriodo =>
        {
          novedadPeriodo.fecha = this.momentService.convertDateServer(novedadPeriodo.fecha);

          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Novedad guardada", "OK", { duration: 10000 });

          this.deshabilitarEdicion();

          this.obtenerHistorial(novedadPeriodo);
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          //novedadPeriodo.desde = novedadPeriodo.desde.replace('Z', '');
          this.novedadMesDetalle.setearForm(novedadPeriodo);
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status === 400)
          {
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.habilitarEdicion();
      this.novedadMesDetalle.form.controls['id'].setValue(0);
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
    }
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarFormDetalle = false;
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarFormDetalle = true;
  }

  private volverAtras()
  {
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    this.MensajeError = "";
    this.novedadesMesHistoryList = [];
    this.novedadesMesList = [];
    this.habilitarFormDetalle = false;
    this.verDetalle = false;
    this.obtenerNovedades(false);
  }

  private obtenerHistorial(novedadMes: NovedadesMes)
  {
    this.novedadesMesService.getHistoryByClase(novedadMes.personal, novedadMes.codigosNomina).subscribe(
      novedadesPeriodos =>
      {
        novedadesPeriodos.forEach((currentValue,index,arr) => {
          currentValue.fecha = this.momentService.convertDateServer(currentValue.fecha);
        });

        this.novedadesMesHistoryList = [];
        novedadesPeriodos.forEach(d =>
        {
          let item = new IboxtoolsItemUnico(d);
          this.novedadesMesHistoryList.push(item);
        });

        this.novedadesMesList = novedadesPeriodos;
        this.verDetalle = true;
        this.novedadMes = novedadMes;
      },
      error =>
      {
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";
    
    if (this.novedadMesDetalle.form.get("moneda").value == 0)
    {
      this.novedadMesDetalle.form.get("moneda").setErrors({ 'invalid': true });
    }
    if (this.novedadMesDetalle.form.get("codigosNomina").value == 0)
    {
      this.novedadMesDetalle.form.get("codigosNomina").setErrors({ 'invalid': true });
    }

    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let desde = this.novedadMesDetalle.form.get("fecha").value.toDateString();
    let hoy = new Date()

    let fingreso = new Date(this.ingreso.desde).toDateString();
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    if (Date.parse(desde) < Date.parse(fingreso))
    {
      this.desdeAnterior = true;
      this.novedadMesDetalle.form.get("fecha").setErrors({'desdeAnterior': true });
    } else {
      //valida que la fecha desde no sea anterior a la fecha de retroactividad del grupo de liquidacion vigente
      if (this.gruposLiquidaciones.periodoRetroactividad != null)
      {
        let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
        if (Date.parse(desde) < Date.parse(fretro) )
        {
          this.anteriorRetroactividad = true;
          this.novedadMesDetalle.form.get("fecha").setErrors({'anteriorRetroactividad': true });
        }
      }
    }

    if (this.novedadMesDetalle.form.valid)
    {
      return true;
    }
    else
    {
      this.novedadMesDetalle.form.markAllAsTouched();
      return false;
    }
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private validacionRetro(desde) : boolean
  {
    let anterior = false;
    
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(desde) < Date.parse(fretro) )
      {
        anterior = true;
        this.snackBar.open("Acción no válida porque es anterior al límite de retroactividad.", "OK");
      }
    }
    return anterior;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    if(edita)
    {
      let anterior = this.validacionRetro(row.desde);
      if(anterior) edita = false;  
    }
    return edita;
  }
}
